import { Navigate, Route, Routes } from 'react-router-dom'
import RequiredAuth from '../Auth/RequiredAuth'
import Settings from '../Pages/Settings/Settings'
import About from '../Pages/About'
import ReportModule from '../Contexts/Modules/ReportModule'
import StudyRouter from './Modules/StudyRouter/StudyRouter'
import ChangeLocation from '../Pages/ChangeLocation'
import HealthRouter from './Modules/ScreenRouter/HealthRouter'
import HealthModule from '../Contexts/Modules/HealthModule/HealthModule'
import BioBankRouter from './Modules/BioBankRouter'
import BioBankModule from '../Contexts/Modules/BioBankModule'
import ReportRouter from './Modules/ReportRouter'
import SampleModule from '../Contexts/Modules/SampleModule/SampleModule'
import SampleRouter from './Modules/SampleRouter/SampleRouter'
import Pricebook from '../Pages/Pricebook/Pricebook'
import ReaderMain from '../Pages/Reader/ReaderMain'
import ReaderSettings from '../Pages/Reader/ReaderSettings'
import ReaderModule from '../Contexts/Modules/ReaderModule/ReaderModule'

export default function MainRouter() {
  return (
    <Routes>
      <Route
        path="/*"
        element={<RequiredAuth />}
      >
        <Route path="stuart">
          <Route
            path="about"
            element={<About />}
          />
          <Route
            path="settings"
            element={<Settings />}
          />
          <Route
            path="location"
            element={<ChangeLocation />}
          />
          {/*Modules - Contain nested switches*/}
          <Route
            path="sample/*"
            element={
              <SampleModule>
                <SampleRouter />
              </SampleModule>
            }
          />
          <Route
            path="health/*"
            element={
              <HealthModule>
                <HealthRouter />
              </HealthModule>
            }
          />
          <Route
            path="study/*"
            element={<StudyRouter />}
          />
          <Route
            path="bio-bank/*"
            element={
              <BioBankModule>
                <BioBankRouter />
              </BioBankModule>
            }
          />
          <Route
            path="pricebook"
            element={<Pricebook />}
          />
          <Route
            path="reader"
            element={
              <ReaderModule>
                <ReaderMain />
              </ReaderModule>
            }
          />
          <Route
            path="reader/settings"
            element={<ReaderSettings />}
          />
          <Route
            path="report/*"
            element={
              <ReportModule>
                <ReportRouter />
              </ReportModule>
            }
          />
          <Route
            index
            element={
              <Navigate
                to={'about'}
                replace={true}
              />
            }
          />
        </Route>
        <Route
          index
          element={
            <Navigate
              to={'stuart/about'}
              replace={true}
            />
          }
        />
      </Route>
    </Routes>
  )
}
